<span  [hidden]="!text">
    {{text}} 
    <span class="align-middle d-inline-block padding-left-10 position-relative top--3px ">
        <input type="checkbox" (click)="onClick($event)" [checked]="isSelected" [disabled] ="isDisabled">
    </span>
</span>